import {
	AttachmentProjectionModifier,
	getContainedProjectionOffset,
} from "@animech/supermodel";
import { AttacherSolverContext } from "./attacher-solver-context";
import { AttributeBond, FamilyType } from "./attacher-attribute";

type CustomAttachmentProjectionModifier = (
	args: Parameters<AttachmentProjectionModifier>[0] & {
		context: Readonly<AttacherSolverContext>;
	},
) => ReturnType<AttachmentProjectionModifier>;

const defaultAttachmentProjectionModifier: CustomAttachmentProjectionModifier =
	(args) => {
		return getContainedProjectionOffset(args.paramMin, args.paramMax);
	};

const attachmenProjectionModifierByFamilyBond: AttributeBond<
	FamilyType,
	AttachmentProjectionModifier
> = {} as const;

export function createAttachmentProjectionModifier(
	context: AttacherSolverContext,
): AttachmentProjectionModifier {
	const { attacherAttributeMap } = context;

	return (args) => {
		const fromFamily = attacherAttributeMap.get("family", args.from);
		const toFamily = attacherAttributeMap.get("family", args.to);

		return (
			attachmenProjectionModifierByFamilyBond[fromFamily]?.[toFamily] ??
			defaultAttachmentProjectionModifier
		)({ ...args, context });
	};
}
